var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuWalletCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Wallet--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wallet Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet--money-payment-finance-wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M0.14 3.9369C0.14 2.0099 1.7021 0.4478 3.6291 0.4478H10.1089C10.3841 0.4478 10.6074 0.671 10.6074 0.9463V2.3399H3.485C3.1409 2.3399 2.862 2.6188 2.862 2.9629C2.862 3.307 3.1409 3.586 3.485 3.586H11.0456C11.0653 3.586 11.0849 3.585 11.1041 3.5833H11.3172C11.7138 3.5833 12.0941 3.7408 12.3745 4.0212C12.655 4.3017 12.8126 4.682 12.8126 5.0786V5.9919H9.8724C9.0505 5.9919 8.1278 6.6147 8.1278 7.6812V9.4541C8.1278 10.5206 9.0505 11.1435 9.8724 11.1435H12.8126V12.0568C12.8126 12.4534 12.655 12.8337 12.3745 13.1142S11.7138 13.5521 11.3172 13.5521L1.6353 13.5522C1.2387 13.5522 0.8584 13.3946 0.578 13.1142C0.2975 12.8337 0.14 12.4534 0.14 12.0569V3.9369ZM9.8724 7.238H13.3616C13.6368 7.238 13.86 7.4365 13.86 7.6812V9.4541C13.86 9.6989 13.6368 9.8974 13.3616 9.8974H9.8724C9.5971 9.8974 9.374 9.6989 9.374 9.4541V7.6812C9.374 7.4365 9.5971 7.238 9.8724 7.238Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWalletCurrent);
export default __webpack_public_path__ + "static/media/menu-wallet-current.a36790b971bbcc57fdfe5b0a136fbc12.svg";
export { ForwardRef as ReactComponent };